import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators, FormArray} from '@angular/forms';
import {RequestService} from 'src/app/core/services/request/request.service';
import {ValidateData} from 'src/app/core/utils/validate-data';

@Component({
    selector: 'app-build-form-request',
    templateUrl: './build-form-request.component.html',
    styleUrls: ['./build-form-request.component.scss'],
    standalone: false
})
export class BuildFormRequestComponent implements OnInit {
  public files: FileList[] = [];

  @Input() idRequestType: number = 1;
  @Input() form: FormGroup;
  @Input() dataJson: any;
  @Input() isArray: boolean = false;
  @Input() responseRequest: any = null;
  @Output() filesOut: EventEmitter<any> = new EventEmitter();

  documents: any = [];
  documentosDigitales: any = [];
  reason: number;
  messageError: string;
  formGroupDocuments: FormGroup;

  constructor(
    public requestService: RequestService,
    private formBuilder: FormBuilder
  ) {
  }

  ngOnInit() {
    this.changeForm();
  }

  async changeForm() {
    if (this.dataJson) {
      this.form.removeControl('documents');

      this.documents = this.dataJson.filter(doc => !doc.nombre);
      this.documentosDigitales = this.dataJson.filter(doc => doc.nombre);

      this.formGroupDocuments = this.formBuilder.group({});

      [...this.documents, ...this.documentosDigitales].forEach((documento) => {
        this.formGroupDocuments.addControl(
          documento.idForm,
          this.formBuilder.control(null, documento.required ? Validators.required : [])
        );
      });

      this.form.addControl('documents', this.formGroupDocuments);
      this.files = Object.values(this.form.get('documents').value);
      for (const documento of this.documentosDigitales) {
        const campo = documento.idForm;
        documento.idForm = documento.id;
        documento.idTipoDocumentoDigital = documento.idTipoDocumento;
        documento.nameFile = documento.label + '.pdf';
        delete documento.id;
        delete documento.type;
        delete documento.required;
        delete documento.label;
        delete documento.maxSizeAttachmentsKb;
        delete documento.propietario;
        const documentoProcesado = await this.procesarDocumentoDigital(documento);
        this.form.get('documents')?.get(campo)?.setValue(documentoProcesado);
      }
      this.limpiarDocumentosNulos();
    } else {
      if (this.form.contains('documents')) {
        this.form.removeControl('documents');
      }
    }
  }

  async onFileChange(file, documento) {
    let campo = documento.idForm;
    this.messageError = !ValidateData.emptyObject(
      this.files.find((document) => document && document['name'] === file.name)
    )
      ? 'Nombre de documento repetido'
      : '';

    this.files = Object.values(this.form.get('documents').value);

    if (file && ValidateData.emptyString(this.messageError)) {
      try {
        file.idForm = documento.id;
        file.idTipoDocumentoDigital = documento.idTipoDocumento;

        const documentoProcesado = await this.procesarDocumento(file);
        this.form.get('documents').get(`${campo}`).setValue(documentoProcesado);

        this.files = Object.values(this.form.get('documents').value);
      } catch (error) {
        console.error('Error procesando el documento:', error);
        this.form.get('documents').get(`${campo}`).setValue(null);
      }
    } else {
      this.form.get('documents').get(`${campo}`).setValue(null);
      this.files = Object.values(this.form.get('documents').value);
      file = null;
    }
    this.limpiarDocumentosNulos();
  }

  delete(fileDelete) {
    this.files = Object.values(this.form.get('documents').value);
    this.limpiarDocumentosNulos();
  }

  validateString(message: string): boolean {
    return ValidateData.emptyString(message);
  }

  private async procesarDocumento(documento: any): Promise<any> {
    if (!documento) return documento;
    try {
      const contenidoBase64 = await this.convertirArchivoABase64(documento);
      return {
        ...documento,
        base64: contenidoBase64,
        revisionManual: true,
        rutaDocumentoDigital: '',
        esDocumentoDigital: false,
      };
    } catch (error) {
      console.error('Error al convertir el archivo a Base64', error);
      return documento;
    }
  }

  private async procesarDocumentoDigital(documento: any): Promise<any> {
    if (!documento) return documento;
    return {
      ...documento,
      base64: '',
      revisionManual: false,
      rutaDocumentoDigital: documento.nombre,
      esDocumentoDigital: true,
    };
  }

  private convertirArchivoABase64(archivo: File): Promise<string> {
    return new Promise((resolver, rechazar) => {
      const lector = new FileReader();
      lector.onload = () => {
        const resultado = lector.result as string;
        const contenidoBase64 = resultado.split(',')[1];
        resolver(contenidoBase64);
      };
      lector.onerror = (error) => {
        console.error('Error al leer el archivo', error);
        rechazar(error);
      };
      lector.readAsDataURL(archivo);
    });
  }

  private limpiarDocumentosNulos(): void {
    const documentsControl = this.form.get('documents');
    if (!documentsControl) return;
    const docsGroup = documentsControl as FormGroup;
    const docsValue = docsGroup.value || {};
    if (Object.prototype.hasOwnProperty.call(docsValue, 'null')) {
      docsGroup.removeControl('null');
    }
  }
}